// src/hooks/transportations/useCreateTransportation.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createTransportation } from "../../api/apiTransportations";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

const useCreateTransportation = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: createTransportationMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: createTransportation,
        onSuccess: (response) => {
            toast.success(response.message);
            navigate('/transportations');
            queryClient.invalidateQueries({ queryKey: ["transportations"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to create transportation");
        },
    });

    return {
        createTransportationMutate,
        isPending: isPending || isLoading,
    };
};

export default useCreateTransportation;
